export enum ViewMode {
    view = 'view',
    edit = 'edit',
    create = 'create'
}
